import React from "react";

import TempTenancy from "components/Settings/Temptenancy";

export default function TempTenancyPage() {
  return <TempTenancy />;
}
